import JsPDF from 'jspdf';

const $inject = [
  '$rootScope',
  '$q',
  '$http',
  'moment',
  'APP_CONFIG',
  'locationService',
  'apiService',
  'ENUMS',
  'locationsSearchService',
  'dateTimeService',
  'settingsService',
  'travelService',
  '$filter',
];

const shareService = function (
  $rootScope,
  $q,
  $http,
  moment,
  APP_CONFIG,
  locationService,
  apiService,
  ENUMS,
  locationsSearchService,
  dateTimeService,
  settingsService,
  travelService,
  $filter
) {
  let service = {
    shareActive: false,
    showSharePage: false,
    shareFlightsDictionary: {},
    sharePackageDictionary: {},
    shareFlightsCount: 0,
    toggleShareItem,
    clearAll,
    clickShare,
    submitEmailRequest,
    copyShareFlightTemplate,
    pdfShareFlightTemplate,
    formatDate,
    formatTime,
    getShareOptions,
    unShareOption,
    getCount,
    isPackageShare,
    getLocationDisplay,
  };

  const TIME_FORMAT = dateTimeService.getFormat(ENUMS.dateTimeFormats.TIME_LONG);
  const DATE_MEDIUM = dateTimeService.getFormat(ENUMS.dateTimeFormats.DATE_MEDIUM);
  const apiDateFormat = 'YYYY-MM-DD[T]HH:mm:ss';

  function formatDate(dateString) {
    return moment(dateString, apiDateFormat).format(DATE_MEDIUM);
  }

  function formatTime(dateTimeString) {
    return moment(dateTimeString, apiDateFormat).format(TIME_FORMAT);
  }
  function isPackageShare() {
    return travelService.hasPackages && travelService.showPackages();
  }
  function getCount() {
    if (isPackageShare()) {
      service.shareFlightsCount = Object.keys(service.sharePackageDictionary).length;
    } else {
      service.shareFlightsCount = Object.keys(service.shareFlightsDictionary).length;
    }
    return service.shareFlightsCount;
  }
  function clickShare() {
    service.shareActive = !service.shareActive;
  }
  function unShareOption(item, fare) {
    toggleShareItem(item.pkg || item.flight, fare, false);
  }
  function toggleShareItem(item, fare, shareStatus) {
    if (fare != null) {
      fare.share = shareStatus == null ? fare.share : shareStatus;
      if (isPackageShare()) {
        if (fare.share === true) {
          addPackageFare(item, fare);
        } else {
          removePackageFare(item, fare);
        }
      } else {
        if (fare.share === true) {
          addFare(item, fare);
        } else {
          removeFare(item, fare);
        }
      }
    } else {
      if (isPackageShare()) {
        item.share = shareStatus == null ? item.share : shareStatus;
        if (item.share === true) {
          addPackage(item);
        } else {
          removePackage(item);
        }
      } else {
        item.share = shareStatus == null ? item.share : shareStatus;
        if (item.share === true) {
          addFlight(item);
        } else {
          removeFlight(item);
        }
      }
    }
    getCount();
  }

  function clearAll() {
    clearAllPackage();
    clearAllUnPackage();
    service.getCount();
  }
  function clearAllUnPackage() {
    var allFlightIdentifiers = Object.keys(service.shareFlightsDictionary);
    allFlightIdentifiers.forEach((flightIdentifier) => {
      var dictionaryItem = service.shareFlightsDictionary[flightIdentifier];
      dictionaryItem.flight.share = false;
      dictionaryItem.faresToShare.forEach((fare) => (fare.share = false));
      delete service.shareFlightsDictionary[flightIdentifier];
    });
  }
  function clearAllPackage() {
    var keys = Object.keys(service.sharePackageDictionary);
    keys.forEach((item) => {
      var dictionaryItem = service.sharePackageDictionary[item];
      dictionaryItem.pkg.share = false;
      dictionaryItem.faresToShare.forEach((fare) => (fare.share = false));
      delete service.sharePackageDictionary[item];
    });
    service.shareFlightsCount = 0;
  }

  function addFlight(flight) {
    service.shareFlightsDictionary[flight.Identifier] = {
      flight,
      flights: [flight],
      faresToShare: [],
    };
  }

  function removeFlight(flight) {
    if (service.shareFlightsDictionary[flight.Identifier]) {
      var dictionaryItem = service.shareFlightsDictionary[flight.Identifier];
      dictionaryItem.flight.share = false;
      dictionaryItem.faresToShare.forEach((fare) => (fare.share = false));
      delete service.shareFlightsDictionary[flight.Identifier];
    }
  }

  function addFare(flight, fare) {
    flight.share = true;
    if (service.shareFlightsDictionary[flight.Identifier]) {
      service.shareFlightsDictionary[flight.Identifier].faresToShare.push(fare);
    } else {
      service.shareFlightsDictionary[flight.Identifier] = {
        flight,
        flights: [flight],
        faresToShare: [fare],
      };
    }
  }

  function removeFare(flight, fare) {
    if (service.shareFlightsDictionary[flight.Identifier]) {
      var dictionaryItem = service.shareFlightsDictionary[flight.Identifier];
      var indexOfFare = dictionaryItem.faresToShare.indexOf(fare);
      if (indexOfFare >= 0) {
        dictionaryItem.faresToShare.splice(indexOfFare, 1);
      }
    }
  }

  function addPackage(pkg) {
    service.sharePackageDictionary[pkg.id] = {
      pkg,
      flights: pkg.Segments.map((f) => f.flight),
      faresToShare: [],
    };
  }

  function removePackage(pkg) {
    if (service.sharePackageDictionary[pkg.id]) {
      var dictionaryItem = service.sharePackageDictionary[pkg.id];
      dictionaryItem.pkg.share = false;
      dictionaryItem.faresToShare.forEach((fare) => (fare.share = false));
      delete service.sharePackageDictionary[pkg.id];
    }
  }

  function addPackageFare(pkg, fare) {
    pkg.share = true;
    if (service.sharePackageDictionary[pkg.id]) {
      service.sharePackageDictionary[pkg.id].faresToShare.push(fare);
    } else {
      service.sharePackageDictionary[pkg.id] = {
        pkg,
        flights: pkg.Segments.map((f) => f.flight),
        faresToShare: [fare],
      };
    }
  }

  function removePackageFare(pkg, fare) {
    if (service.sharePackageDictionary[pkg.id]) {
      var dictionaryItem = service.sharePackageDictionary[pkg.id];
      var indexOfFare = dictionaryItem.faresToShare.indexOf(fare);
      if (indexOfFare >= 0) {
        dictionaryItem.faresToShare.splice(indexOfFare, 1);
      }
    }
  }

  function getShareOptions() {
    if (isPackageShare()) {
      return getGroupedPackaged();
    }
    return getGroupedUnPackaged();
  }
  function getGroupedUnPackaged() {
    let results = [];
    let keys = Object.keys(service.shareFlightsDictionary);
    keys.forEach((id) => {
      let option = service.shareFlightsDictionary[id];

      let searchItem = results.find((d) => d.Searches.find((s) => s.searchIdentifier === option.flights[0].SearchIdentifier));
      if (searchItem == null) {
        let search = travelService.results.find((r) => r.searchIdentifier === option.flights[0].SearchIdentifier);
        searchItem = {
          Searches: [search],
          Options: [],
        };
        results.push(searchItem);
      }
      searchItem.Options.push(option);
    });
    return results;
  }
  function getGroupedPackaged() {
    let results = [];
    let keys = Object.keys(service.sharePackageDictionary);
    keys.forEach((id) => {
      let option = service.sharePackageDictionary[id];

      let searchItem = results.find((d) => d.Searches.some((s) => s.searchIdentifier === option.flights[0].SearchIdentifier));
      if (searchItem == null) {
        searchItem = {
          Searches: [],
          Options: [],
        };
        option.flights.forEach((flight) => {
          searchItem.Searches.push(travelService.results.find((r) => r.searchIdentifier === flight.SearchIdentifier));
        });
        results.push(searchItem);
      }
      searchItem.Options.push(option);
    });
    return results;
  }
  function getSelectedFare(displayFare) {
    if (displayFare && displayFare.PackageFares && displayFare.PackageFares[0]) {
      return {
        FareParts: displayFare.PackageFares.map((p) => p.Identifier),
      };
    }
    return {
      FareParts: [displayFare.Identifier],
    };
  }
  function submitEmailRequest(emailAddresses, emailMessage) {
    let deferred = $q.defer();
    let request = {
      emailAddresses,
      emailMessage,
      legs: [],
    };
    let shareOptions = getShareOptions();

    shareOptions.forEach((leg) => {
      request.legs.push({
        SearchIdentifiers: leg.Searches.map((s) => s.searchIdentifier),
        Options: leg.Options.map((o) => {
          return {
            flights: o.flights.map((f) => f.Identifier),
            fares: o.faresToShare.map((f) => getSelectedFare(f)),
          };
        }),
      });
    });

    $http
      .post(`${APP_CONFIG.api.emailShareFlightOptions}`, request)
      .then((response) => {
        let data = response.data;
        if (!data) {
          deferred.reject('Failed to submit Email Request. Server did not respond.');
        } else if (data.IsSuccess !== true) {
          deferred.reject('Failed to submit Email Request. ' + data.Message);
        } else {
          deferred.resolve(data);
        }
      })
      .catch(() => {
        deferred.reject('Failed to submit Email Request');
      });

    return deferred.promise;
  }

  function pdfShareFlightTemplate() {
    let deferred = $q.defer();
    let htmlContent =
      '<title>Flight Options</title></head><body style="font-family: Arial, sans-serif;"><div style="align-items: center;"><div><h1 style="font-size: 24px; margin-bottom: 10px;">Flight options</div></div>';
    let TextContent = '';

    let basicSytle = "font-family: 'Arial', sans-serif; line-height: 18px; text-align: center; ";
    let titleSection = basicSytle + 'font-size: 14px;color: #2D3840;';
    let normalSection = basicSytle + 'font-size: 12px;color: #2D3840;';
    let blueSection = basicSytle + 'font-size: 12px;color: #0072c3;';

    let shareOptions = getShareOptions();
    let legs = [];

    shareOptions.forEach((leg) => {
      legs.push({
        SearchIdentifiers: leg.Searches.map((s) => s.searchIdentifier),
        Searches: leg.Searches,
        Options: leg.Options.map((o) => {
          return {
            flights: o.flights,
            fares: o.faresToShare,
          };
        }),
      });
    });

    ///Create template
    legs.forEach((leg) => {
      htmlContent += '<div><hr style="border-top: 1px solid #c0c0c0;"><div>&nbsp;</div></div>';
      htmlContent += `<div style="padding-left:8px; margin-left:10px">`;
      leg.Searches.forEach((search) => {
        //Leg

        htmlContent +=
          `<div style="${titleSection}font-weight:bold;padding-top:20px;">${formatDate(search.searchDate)} | ${search.origin.Code} - ${
            search.destination.Code
          }</div>` + `<div style="${titleSection}">${getLocationDisplay(search.origin)} to ${getLocationDisplay(search.destination)}</div>`;

        TextContent +=
          `${formatDate(search.searchDate)} | ${search.origin.Code} - ${search.destination.Code}\r\n` +
          `${getLocationDisplay(search.origin)} to ${getLocationDisplay(search.destination)}\r\n\r\n`;
      });
      //Options
      leg.Options.forEach((option, optIndex) => {
        htmlContent += `<div>`;
        htmlContent += `<div>  </div>`;
        htmlContent += `<div style="${blueSection}font-weight:bold;padding-top:15px;text-align:center;padding-left:10px">Option ${
          optIndex + 1
        }</div>`;
        TextContent += `Option ${optIndex + 1}\r\n`;

        option.flights.forEach((flight) => {
          let stops = 'Nonstop';
          if (flight.Stops > 0) {
            stops = `${flight.Stops} stop` + (flight.Stops > 1 ? 's' : '');
          }
          let tripDayDisplay = '';
          if (flight.TripDays != 0) {
            tripDayDisplay = ` (${flight.TripDays > 0 ? '+' : '-'}${flight.TripDays} day${
              flight.TripDays > 1 || flight.TripDays < -1 ? 's' : ''
            })`;
          }
          let flightLine = `${flight.OriginLocationCode} ${formatTime(flight.DepartureDateTimeOffset)} - ${
            flight.DestinationLocationCode
          } ${formatTime(flight.ArrivalDateTimeOffset)}${tripDayDisplay} | ${flight.TotalTravelTime}, ${stops}`;

          htmlContent += `<div style="${normalSection}font-weight:bold;">${flightLine}</div>`;
          TextContent += `${flightLine}\r\n`;

          let carriers = flight.Details.map((seg) => `${seg.CarrierName} (${seg.Carrier})`);
          carriers = [...new Set(carriers)];
          let carrierLine = carriers.join(' ');
          htmlContent += `<div style="${normalSection}">${carrierLine}</div>`;
          TextContent += `${carrierLine}\r\n`;

          htmlContent += `<div style="${normalSection}><ul style="padding-bottom:-10px">`;

          flight.Details.forEach((segment, segIndex) => {
            let nextSeg = flight.Details[segIndex + 1];
            let segText = `${segment.Carrier}${segment.TripNumber} ${formatTime(segment.DepartureDateTimeOffset)} ${
              segment.Origin.Code
            } - ${segment.Destination.Code} | ${segment.ElapsedTime}`;
            if (flight.AircraftName) {
              segText += ` | ${flight.AircraftName}`;
            }
            if (nextSeg && nextSeg.Layover) {
              segText += ` | Layover (${segment.Destination.Code}): ${nextSeg.Layover}`;
            }

            htmlContent += `<li>${segText}</li>`;
            TextContent += `\t${segText}\r\n`;
          });
        });
        if (option.fares && option.fares.length > 0) {
          htmlContent += `<div style="${normalSection}font-weight:bold;">Fares</div>`;
          TextContent += `\r\nFares\r\n`;
          option.fares.forEach((fare) => {
            let fareName = fare.FareNames ? fare.FareNames[0] : fare.FareName;
            if (fareName == null || fareName == undefined) fareName = fare.FareDescription;

            let fareLine = `${fareName} ${$filter('currency')(fare.Amount, '')} ${fare.CurrencyCode}`;
            htmlContent += `<div style="${normalSection}">${fareLine}</div>`;
            TextContent += `${fareLine}\r\n`;
          });
        }
        htmlContent += `</ul></div>`;
        htmlContent += `</div>`;
        TextContent += `\r\n\r\n`;
      });
      htmlContent += `</body></div>`;
    });

    const doc = new JsPDF();
    doc.fromHTML(htmlContent);
    doc.save('FlightOptions.pdf');
  }

  function copyShareFlightTemplate() {
    let htmlContent = '';
    let TextContent = '';
    //Orginal Package Shopping
    let basicSytle = "font-family: 'Arial', sans-serif; line-height: 18px; text-align: left; ";
    let titleSection = basicSytle + 'font-size: 14px;color: #2D3840;';
    let normalSection = basicSytle + 'font-size: 12px;color: #2D3840;';
    let blueSection = basicSytle + 'font-size: 12px;color: #0072c3;';

    let shareOptions = getShareOptions();
    let request = {
      legs: [],
    };
    shareOptions.forEach((leg) => {
      request.legs.push({
        SearchIdentifiers: leg.Searches.map((s) => s.searchIdentifier),
        Searches: leg.Searches,
        Options: leg.Options.map((o) => {
          return {
            flights: o.flights,
            fares: o.faresToShare,
          };
        }),
      });
    });
    ///Create template
    request.legs.forEach((leg) => {
      htmlContent += `<div style="padding-left:8px;">`;
      leg.Searches.forEach((search) => {
        //Leg

        htmlContent +=
          `<div style="${titleSection}font-weight:bold;">${formatDate(search.searchDate)} | ${search.origin.Code} - ${
            search.destination.Code
          }</div>` + `<div style="${titleSection}">${getLocationDisplay(search.origin)} to ${getLocationDisplay(search.destination)}</div>`;

        TextContent +=
          `${formatDate(search.searchDate)} | ${search.origin.Code} - ${search.destination.Code}\r\n` +
          `${getLocationDisplay(search.origin)} to ${getLocationDisplay(search.destination)}\r\n\r\n`;
      });
      //Options
      leg.Options.forEach((option, optIndex) => {
        htmlContent += `<div style="padding-bottom:16px;padding-left:8px;">`;
        htmlContent += `<div style="${blueSection}font-weight:bold;">Option ${optIndex + 1}</div>`;
        TextContent += `Option ${optIndex + 1}\r\n`;

        option.flights.forEach((flight) => {
          let stops = 'Nonstop';
          if (flight.Stops > 0) {
            stops = `${flight.Stops} stop` + (flight.Stops > 1 ? 's' : '');
          }
          let tripDayDisplay = '';
          if (flight.TripDays != 0) {
            tripDayDisplay = ` (${flight.TripDays > 0 ? '+' : '-'}${flight.TripDays} day${
              flight.TripDays > 1 || flight.TripDays < -1 ? 's' : ''
            })`;
          }
          let flightLine = `${flight.OriginLocationCode} ${formatTime(flight.DepartureDateTimeOffset)} - ${
            flight.DestinationLocationCode
          } ${formatTime(flight.ArrivalDateTimeOffset)}${tripDayDisplay} | ${flight.TotalTravelTime}, ${stops}`;

          htmlContent += `<div style="${normalSection}font-weight:bold;">${flightLine}</div>`;
          TextContent += `${flightLine}\r\n`;

          let carriers = flight.Details.map((seg) => `${seg.CarrierName} (${seg.Carrier})`);
          carriers = [...new Set(carriers)];
          let carrierLine = carriers.join(' ');
          htmlContent += `<div style="${normalSection}">${carrierLine}</div>`;
          TextContent += `${carrierLine}\r\n`;

          htmlContent += `<div style="${normalSection}"><ul>`;

          flight.Details.forEach((segment, segIndex) => {
            let nextSeg = flight.Details[segIndex + 1];
            let segText = `${segment.Carrier}${segment.TripNumber} ${formatTime(segment.DepartureDateTimeOffset)} ${
              segment.Origin.Code
            } - ${segment.Destination.Code} | ${segment.ElapsedTime}`;
            if (flight.AircraftName) {
              segText += ` | ${flight.AircraftName}`;
            }
            if (nextSeg && nextSeg.Layover) {
              segText += ` | Layover (${segment.Destination.Code}): ${nextSeg.Layover}`;
            }

            htmlContent += `<li>${segText}</li>`;
            TextContent += `\t${segText}\r\n`;
          });
          htmlContent += `</ul></div>`;
        });
        if (option.fares && option.fares.length > 0) {
          htmlContent += `<div style="${normalSection}font-weight:bold;">Fares</div>`;
          TextContent += `\r\nFares\r\n`;
          option.fares.forEach((fare) => {
            let fareName = fare.FareNames ? fare.FareNames[0] : fare.FareName;
            if (fareName == null || fareName == undefined) fareName = fare.FareDescription;
            let fareLine = `${fareName} ${$filter('currency')(fare.Amount, '')} ${fare.CurrencyCode}`;
            htmlContent += `<div style="${normalSection}">${fareLine}</div>`;
            TextContent += `${fareLine}\r\n`;
          });
        }
        htmlContent += `</div>`;
        TextContent += `\r\n\r\n`;
      });
      htmlContent += `</div>`;
    });

    //End create template
    navigator.clipboard
      .write([
        new ClipboardItem({
          'text/html': new Blob([htmlContent], { type: 'text/html' }),
          'text/plain': new Blob([TextContent], { type: 'text/plain' }),
        }),
      ])
      .then(function () {
        var successMessage = document.getElementById('successMessage');
        successMessage.style.display = 'block';
        setTimeout(function () {
          successMessage.style.display = 'none';
        }, 3000);
      })
      .catch(function (err) {
        console.error('Failed to copy: ', err);
      });
  }

  function getLocationDisplay(loc) {
    if (loc.LocationType === 'CustomHub' && loc.Location) {
      return `${loc.Location}`;
    }
    return `${loc.City} (${loc.Code})`;
  }

  return service;
};

shareService.$inject = $inject;

export default shareService;



// WEBPACK FOOTER //
// ./src/services/shareService.js